import { H5 } from '../../../AbstractElements';
import React, { Fragment } from 'react';
import { CardHeader } from 'reactstrap';

const HeaderCard = ({ title, span1, span2, mainClasses, rightContent }) => {
	return (
		<Fragment>
			<CardHeader className={`${mainClasses ? mainClasses : ''}`}>
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<H5>{title}</H5>
						{span1 ? <span>{span1}</span> : ''}
						{span2 ? <span>{span2}</span> : ''}
					</div>
					{rightContent && <div>{rightContent}</div>}
				</div>
			</CardHeader>
		</Fragment>
	)
}

export default HeaderCard;
